import { Trash2, Smartphone } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { DoorCredential } from '@/api/door';

const STATUS_CONFIG: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  pending: { label: 'Ожидает', variant: 'secondary' },
  approved: { label: 'Одобрен', variant: 'default' },
  rejected: { label: 'Отклонён', variant: 'destructive' },
  archived: { label: 'Удалён', variant: 'outline' },
};

interface Props {
  credentials: DoorCredential[];
  onArchive: (id: string) => void;
  isArchiving: boolean;
}

export function CredentialsList({ credentials, onArchive, isArchiving }: Props) {
  if (credentials.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-4">
        Нет зарегистрированных устройств
      </p>
    );
  }

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-muted-foreground">Устройства</h3>
      {credentials.map((cred) => {
        const config = STATUS_CONFIG[cred.status] || STATUS_CONFIG.pending;
        const isArchived = cred.status === 'archived';

        return (
          <div
            key={cred.id}
            className={`flex items-center gap-3 p-3 rounded-lg border ${
              isArchived ? 'opacity-50 bg-muted' : 'bg-card'
            }`}
          >
            <Smartphone className="w-5 h-5 text-muted-foreground shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">
                {cred.deviceName || 'Устройство'}
              </p>
              <p className="text-xs text-muted-foreground">
                {new Date(cred.createdAt).toLocaleDateString('ru-RU')}
                {cred.archivedReason === 'admin_revoked' && ' — отозвано админом'}
                {cred.archivedReason === 'user_deleted' && ' — удалено'}
              </p>
            </div>
            <Badge variant={config.variant}>{config.label}</Badge>
            {!isArchived && cred.status !== 'rejected' && (
              <Button
                variant="ghost"
                size="icon"
                className="shrink-0 h-8 w-8"
                onClick={() => onArchive(cred.id)}
                disabled={isArchiving}
              >
                <Trash2 className="w-4 h-4 text-destructive" />
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
}
